/**
 * NAOKO — Product Block (grid): przycisk „Pokaż więcej".
 *
 * Markup (sections/product-block.liquid, layout = grid):
 *   <product-block-grid data-step="10">
 *     <ul class="product-block-grid"> … początkowe karty … </ul>
 *     <template data-pb-showmore> … pozostałe karty (<li class="product">) … </template>
 *     <div class="product-block__more"><button class="pb-show-more">…</button></div>
 *   </product-block-grid>
 *
 * Klik = przeniesienie kolejnych `data-step` kart z <template> do siatki.
 * Gdy szablon się wyczerpie — przycisk znika. Karty są w pełni wyrenderowane
 * (snippet product-card-naoko), więc skrypty kart (hover-video, kopiowanie kodu)
 * obsługują je przez delegację na document; <wish-list> inicjalizuje się sam
 * po wstawieniu do DOM.
 */
if (!customElements.get('product-block-grid')) {
  customElements.define(
    'product-block-grid',
    class ProductBlockGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.product-block-grid');
        this.template = this.querySelector('template[data-pb-showmore]');
        this.button = this.querySelector('.pb-show-more');
        this.moreWrap = this.querySelector('.product-block__more');
        if (!this.grid || !this.template || !this.button) return;

        const step = parseInt(this.getAttribute('data-step'), 10);
        this.step = step > 0 ? step : Infinity;

        this.button.addEventListener('click', this.reveal.bind(this));
      }

      reveal() {
        // template.content.children to żywa kolekcja — appendChild przenosi węzeł
        // i kolekcja się kurczy, więc wielokrotnie sięgamy po children[0].
        const items = this.template.content.children;
        const count = Math.min(this.step, items.length);
        const frag = document.createDocumentFragment();
        for (let i = 0; i < count; i++) {
          frag.appendChild(items[0]);
        }
        this.grid.appendChild(frag);

        if (items.length === 0 && this.moreWrap) {
          this.moreWrap.remove();
        }
      }
    }
  );
}
